export default __webpack_public_path__ + "static/media/section-bg-search-slide2.0b73a3b2.jpg";